var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-dialog modal-lg site-tree-modal" }, [
    _c("div", { staticClass: "modal-content" }, [
      _c(
        "div",
        { staticClass: "modal-header" },
        [
          _c(_setup.SiteTreeNavigationMenu, {
            staticClass: "w-auto",
            attrs: { "site-tree-id": _setup.siteTreeId },
          }),
          _vm._v(" "),
          _c("button", {
            staticClass: "btn-close",
            attrs: { "aria-label": "Close", type: "button" },
            on: {
              click: function ($event) {
                return _vm.$emit("hide-modal")
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-body" },
        [_c(_setup.SiteTree, { attrs: { "site-tree-id": _setup.siteTreeId } })],
        1
      ),
      _vm._v(" "),
      _setup.propagatedContentId
        ? _c("div", { staticClass: "modal-footer" }, [
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _setup.saveSelectedPageIds.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  _setup.Button,
                  {
                    staticClass: "ms-1 border",
                    attrs: {
                      type: "submit",
                      disabled: _setup.isSaveBtnDisabled,
                      "active-class": "btn-warning",
                      "active-value": !_setup.isSaveBtnDisabled,
                    },
                  },
                  [_vm._v("\n                    Save\n                ")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }